/**
 * Created by dziamid on 27/06/17.
 */
export const SUBSCRIBE = 'socket/SUBSCRIBE';
export const UNSUBSCRIBE = 'socket/UNSUBSCRIBE';
